if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.productVariants = document.querySelector('[data-product-variants]');
      this.productVariantsError = document.querySelector('.product__variant-selector-error-desktop');
      this.productVariantsErrorMobile = document.querySelector('.product__variant-selector-error-mobile');
    }

    checkIfVariantSelected() {
      const selectedVariant = this.productVariants?.querySelector('input:checked');

      if (selectedVariant == null) {
        return false;
      } else {
        return true;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (window.variantSelected == true && window.location.pathname.includes('/products/') || !window.location.pathname.includes('/products/')) {
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id)
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      if (window.variantSelected == true && window.location.pathname.includes('/products/') || !window.location.pathname.includes('/products/')) {

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.status == 422) {
              // When quantity error
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
              return;
            }

            if (window.location.pathname.includes('/products/')) {
              if (window.variantSelected == undefined) {
                if (window.innerWidth > 768) {
                  this.productVariantsError?.classList.add('product-variant-selector--error-visible');
                } else {
                  this.productVariantsErrorMobile?.classList.add('product-variant-selector--error-visible');
                }
              }
              else if (window.variantSelected == true) {
                if (window.innerWidth > 768) {
                  this.productVariantsError?.classList.remove('product-variant-selector--error-visible');
                } else {
                  this.productVariantsErrorMobile?.classList.remove('product-variant-selector--error-visible');
                }
              }
            }

            this.cartDrawer.renderContents(parsedState);

            switch (submitButton.dataset.addToCartBehavior) {
              case ('open_cart_drawer'):
                this.cartDrawer.open();
                break;
              case ('show_cart_notification'):
              default:
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderContents(parsedState);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          });
      }
      else if(window.variantSelected == undefined && window.location.pathname.includes('/products/')) {
        if (window.innerWidth > 768) {
          this.productVariantsError?.classList.add('product-variant-selector--error-visible');
        } else {
          this.productVariantsErrorMobile?.classList.add('product-variant-selector--error-visible');
        }
      }
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


